import { render, staticRenderFns } from "./ListNoData.vue?vue&type=template&id=f5272e88&scoped=true&"
import script from "./ListNoData.vue?vue&type=script&lang=js&"
export * from "./ListNoData.vue?vue&type=script&lang=js&"
import style0 from "./ListNoData.vue?vue&type=style&index=0&id=f5272e88&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5272e88",
  null
  
)

export default component.exports